var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterUpperImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 930.207,
    height: 176.234,
    viewBox: "0 0 930.207 176.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(-224 -6476.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_57",
    "data-name": "Path 57",
    transform: "translate(236 6519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 917.5 133.4999847412109 L 570.4840087890625 133.4999847412109 L 324.9425964355469 133.4999847412109 L 0.2083763629198074 133.4999847412109 L -11.42661571502686 121.7623291015625 L 0.4803486168384552 -1.553799510002136 L 28.54865837097168 -29.5027904510498 L 905.8008422851562 -41.52394104003906 L 917.5 -29.79335021972656 L 917.5 133.4999847412109 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 905.5960693359375 -41.02116394042969 L 28.75799560546875 -29.00568389892578 L 0.9608154296875 -1.326797485351562 L -10.90631103515625 121.5769271850586 L 0.4168701171875 132.9999847412109 L 917 132.9999847412109 L 917 -29.58667755126953 L 905.5960693359375 -41.02116394042969 M 906.0053100585938 -42.02684020996094 L 918 -30.00001525878906 L 918 133.9999847412109 L 0 133.9999847412109 L -11.94677734375 121.9477462768555 L 0 -1.78131103515625 L 28.33929443359375 -30.00001525878906 L 906.0053100585938 -42.02684020996094 Z",
    stroke: "none",
    fill: "#e5bf00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_56",
    "data-name": "Path 56",
    transform: "translate(224 6507)",
    fill: "#e5bf00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 917.5 133.5 L 582.54833984375 133.5 L 336.9793395996094 133.5 L 0.5 133.5 L 0.5 -1.573484778404236 L 28.54582214355469 -29.5 L 917.5 -29.5 L 917.5 133.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.75225830078125 -29 L 1 -1.365806579589844 L 1 133 L 917 133 L 917 -29 L 28.75225830078125 -29 M 28.33929443359375 -30 L 918 -30 L 918 134 L 0 134 L 0 -1.781295776367188 L 28.33929443359375 -30 Z",
    stroke: "none",
    fill: "#e5bf00"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 12,
    y2: 12,
    transform: "translate(1141.5 6640.5)",
    fill: "none",
    stroke: "#ffca65",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterUpperImg);
export default __webpack_public_path__ + "static/media/footerUpperImg.c978f68e2c286b830f18ec8003528388.svg";
export { ForwardRef as ReactComponent };